export const staticState = {
  page_number: 1,
  count_per_page: 10,
  search: "",
  filters: {
    status: "accepted",
  },
};
